// Components
import Navbar from '../../components/Navbar/navbar';
import Intro from '../../components/Intro/intro';
import Esiintymiset from '../../components/esiintymiset/esiintymiset';
import Media from '../../components/media/media';
import About from '../../components/About/About';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import SongsBrowser from '../../components/ohjelmisto/ohjelmisto';
import FAQ from '../../components/FAQ/FAQ';

export default function Home() {
  return (
    <>
      <Navbar />
      <div className="container">
        <Intro />
        <About />
        <SongsBrowser />
        <Media />
        <Esiintymiset />
        <FAQ />
        
      </div>

      <ScrollToTop />
    </>
  );
}
